import CustomModal from "../../../common/components/modal/CustomDetailModal";
import { Divider, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import Translate from "../../../common/translate/Translate";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import React, { useEffect, useState } from "react";
import CustomPopup from "../../../common/components/popup/CustomPopup";
import { TitleAndInput } from "../../../common/components/input/TitleAndInput";
import { C3Text } from "../../../common/components/text/CustomText";
import { Theme } from "../../../common/Theme";
import SettingsService from "../../../service/SettingsService";

export default function CourseAddImageModal({ isOpen, onClose, onSave }) {
    const service = new SettingsService();
    // Cancel 팝업
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);

    // state
    const [number, setNumber] = useState("");
    const [currentVersion, setCurrentVersion] = useState("");
    const [image, setImage] = useState(undefined);

    // 용량 초과 팝업
    const [isSizePopupOpen, setIsSizePopupOpen] = useState(false);

    // 버튼 활성화 여부
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    useEffect(() => {
        setIsButtonDisabled(number === "" || currentVersion === "" || !image || image.length === 0);
    }, [number, currentVersion, image]);

    useEffect(() => {
        if (image && image.length > 0 && image[0] !== undefined && image[0].size >= 512000) {
            setIsSizePopupOpen(true);
            setImage([]);
        }
    }, [image]);

    return (
        <CustomModal
            title={"Add Image"}
            isOpen={isOpen}
            onClose={onClose}
            width={"552px"}
            side={"right"}
            height={"90vh"}
            bottomButtons={
                <Row justifyContent={"flex-end"} width={"100%"} padding={"22px 20px"}>
                    <SecondaryButton
                        text={Translate("common.cancel")}
                        width={"70px"}
                        padding={"7.75px 14.5px"}
                        onClick={() => {
                            setIsCancelPopupOpen(true);
                        }}
                    />
                    <SizedBox width={"10px"} />
                    <PrimaryButton
                        text={Translate("common.save")}
                        width={"70px"}
                        padding={"7.75px 14.5px"}
                        onClick={() => {
                            if (!image || image.length === 0) return;
                            service
                                .uploadCourseImage({ imageNum: number, version: currentVersion, content: image[0] })
                                .then(() => {
                                    if (onSave) onSave();
                                    onClose();
                                })
                                .catch((error) => {
                                    console.error("Error uploading course image:", error);
                                });
                        }}
                        disabled={isButtonDisabled}
                    />
                </Row>
            }
        >
            <SizedBox
                width={"100%"}
                height={"auto"}
                border={"solid 1px #E6E6E9"}
                borderRadius={"16px"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                padding={"16px"}
            >
                <TitleAndInput
                    title={"Number"}
                    type={"normal"}
                    placeholder={"Please enter the number"}
                    inputValue={number}
                    setInputValue={setNumber}
                    disabled={false}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"Current Version"}
                    type={"normal"}
                    placeholder={"Please enter the current version"}
                    inputValue={currentVersion}
                    setInputValue={setCurrentVersion}
                    disabled={false}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"Image"}
                    type={"courseImage"}
                    placeholder={""}
                    inputValue={image}
                    setInputValue={setImage}
                    tooltip={<C3Text fontColor={Theme.color.gray500}>Please upload an image up to 500kb.</C3Text>}
                    tooltipTop={"-320%"}
                />
            </SizedBox>
            <CustomPopup
                isOpen={isCancelPopupOpen}
                onClose={() => setIsCancelPopupOpen(false)}
                onConfirm={() => onClose()}
                message={Translate("popup.cancel")}
            />
            <CustomPopup
                isOpen={isSizePopupOpen}
                onConfirm={() => setIsSizePopupOpen(false)}
                message={"The file is too large. Please upload an image under 500kb"}
            />
        </CustomModal>
    );
}
